import type { SimpleStyleT } from "tweenly"
export const visibility: SimpleStyleT = {
    property: "visibility",
    value: "visible",
    input: {
        type: "string",
        props: "",
    },
    render: (value) => ({ property: "visibility", value: value }),
}
